import { ItfInfo, ItfInit } from './type';

export const dataAll: Record<'us' | 'ca', ItfInit[]> = {
    us: [
        // 1.
        {
            ...({} as ItfInit),
            productId: '15416991711305',
            variantId: '54815758483529',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder', 'amazon'], ['preorder'], ['buy']],
            tag: 'NEW',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FYCJXXC8?maas=maas_adg_2E89860C4146BB95543EDFBD5184FB3C_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-power-bank-built-in-usb-c-cable?variant=54815758483529',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank (Built-in USB-C Cable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932287156/1_white.png',
        },
        // 2.
        {
            ...({} as ItfInit),
            productId: '15416991711305',
            variantId: '54815758450761',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder', 'amazon'], ['preorder'], ['buy']],
            tag: 'NEW',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FY6WBDMP?maas=maas_adg_7D52E855B4B31F0A254D5FD5A8AAECC8_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-power-bank-built-in-usb-c-cable?variant=54815758450761',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank (Built-in USB-C Cable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286102/1_black.png',
        },
        // 3.
        {
            ...({} as ItfInit),
            productId: '15416992170057',
            variantId: '54815759892553',
            stageMapping: [[''], ['notify'], ['notify'], ['buy', 'amazon'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FXX6NL3X?maas=maas_adg_4633CAF3FBD32DEFDC493C7C19A847AA_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-power-bank?variant=54815759892553',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286251/2_white.png',
        },
        // 4.
        {
            ...({} as ItfInit),
            productId: '15416992170057',
            variantId: '54815759859785',
            stageMapping: [[''], ['notify'], ['notify'], ['buy', 'amazon'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FXY1HXHZ?maas=maas_adg_1C3272642E5800DE035C2FD6ACA11F07_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-power-bank?variant=54815759859785',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286420/2_black.png',
        },
        // 5.
        {
            ...({} as ItfInit),
            productId: '15361642856521',
            variantId: '54593882685513',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 6.
        {
            ...({} as ItfInit),
            productId: '15361642856521',
            variantId: '54593882488905',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 7.
        {
            ...({} as ItfInit),
            productId: '15361644593225',
            variantId: '54593884684361',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 8.
        {
            ...({} as ItfInit),
            productId: '15361644593225',
            variantId: '54593884651593',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 9.
        {
            ...({} as ItfInit),
            productId: '7302855557193',
            variantId: '41843266584649',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 10.
        {
            ...({} as ItfInit),
            productId: '7302855557193',
            variantId: '54347781832777',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 11.
        {
            ...({} as ItfInit),
            productId: '7302855557193',
            variantId: '42105281577033',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'lightblue',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 12.
        {
            ...({} as ItfInit),
            productId: '7395983294537',
            variantId: '54612044054601',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // Accessory
        // 13.
        {
            ...({} as ItfInit),
            productId: '15416976769097',
            variantId: '54815716507721',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FY6SWSHK?maas=maas_adg_E5BB45D9232D4516BAE087EA8572A1EA_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-wireless-charging-station-3-in-1-foldable?variant=54815716507721',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Station (3-in-1 Foldable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 14.
        {
            ...({} as ItfInit),
            productId: '15416976769097',
            variantId: '54815716474953',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FYC96MRF?maas=maas_adg_24F7DA829F57EEB808F6498FF35A9D81_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-wireless-charging-station-3-in-1-foldable?variant=54815716474953',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Station (3-in-1 Foldable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
    ],
    ca: [
        // 1.
        {
            ...({} as ItfInit),
            productId: '15219601539443',
            variantId: '62251972231539',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder', 'amazon'], ['preorder'], ['buy']],
            tag: 'NEW',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.ca/dp/B0FYCJXXC8?maas=maas_adg_050EC1064EEE5789882942E271397446_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://ca.ecoflow.com/products/ecoflow-rapid-mag-power-bank-built-in-usb-c-cable?variant=62251972231539',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank (Built-in USB-C Cable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932287156/1_white.png',
        },
        // 2.
        {
            ...({} as ItfInit),
            productId: '15219601539443',
            variantId: '62251972198771',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder', 'amazon'], ['preorder'], ['buy']],
            tag: 'NEW',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.ca/dp/B0FY6WBDMP?maas=maas_adg_7A1D1B92750349906547DA0508788F80_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://ca.ecoflow.com/products/ecoflow-rapid-mag-power-bank-built-in-usb-c-cable?variant=62251972198771',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank (Built-in USB-C Cable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286102/1_black.png',
        },
        // 3.
        {
            ...({} as ItfInit),
            productId: '15219601015155',
            variantId: '62251969380723',
            stageMapping: [[''], ['notify'], ['notify'], ['buy', 'amazon'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.ca/dp/B0FXX6NL3X?maas=maas_adg_A61C0CA01DD3A7F6CDEBBF5426C1EB1E_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: 'https://ca.ecoflow.com/products/ecoflow-rapid-mag-power-bank?variant=62251969380723',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286251/2_white.png',
        },
        // 4.
        {
            ...({} as ItfInit),
            productId: '15219601015155',
            variantId: '62251969347955',
            stageMapping: [[''], ['notify'], ['notify'], ['buy', 'amazon'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.ca/dp/B0FXY1HXHZ?maas=maas_adg_3C11BCF5539B55095E377981C37DD7C3_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://ca.ecoflow.com/products/ecoflow-rapid-mag-power-bank?variant=62251969347955',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286420/2_black.png',
        },
        // 5.
        {
            ...({} as ItfInit),
            productId: '15126377234803',
            variantId: '52731645493619',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 6.
        {
            ...({} as ItfInit),
            productId: '15126377234803',
            variantId: '52731645460851',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 7.
        {
            ...({} as ItfInit),
            productId: '15126380118387',
            variantId: '52731646509427',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 8.
        {
            ...({} as ItfInit),
            productId: '15126380118387',
            variantId: '52731646476659',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 9.
        {
            ...({} as ItfInit),
            productId: '8339992051866',
            variantId: '45181875421338',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 10.
        {
            ...({} as ItfInit),
            productId: '15040389579123',
            variantId: '52359916388723',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 11.
        {
            ...({} as ItfInit),
            productId: '15219601801587',
            variantId: '62251973378419',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.ca/dp/B0FY6SWSHK?maas=maas_adg_324403D7B1CA9565BFD27D06C42FD6DC_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://ca.ecoflow.com/products/ecoflow-rapid-mag-wireless-charging-station-3-in-1-foldable?variant=62251973378419',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Station (3-in-1 Foldable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 12.
        {
            ...({} as ItfInit),
            productId: '15219601801587',
            variantId: '62251973345651',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.ca/dp/B0FYC96MRF?maas=maas_adg_834E984785A834B2C07014E1C53E3CBE_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://ca.ecoflow.com/products/ecoflow-rapid-mag-wireless-charging-station-3-in-1-foldable?variant=62251973345651',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Station (3-in-1 Foldable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
    ],
};

export const dataInfo: Record<string, ItfInfo[]> = {
    // us
    '15416991711305': [
        { name: '25W Wireless Output', text: 'Qi2.2 Certified' },
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '36W', text: 'Built-in USB-C Cable' },
    ],
    '15416992170057': [
        { name: '15W Wireless Output', text: 'Qi2 Certified' },
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: 'Multi angled', text: 'Foldable Kickstand' },
    ],
    '15361642856521': [
        { name: '5,000mAh', text: 'Massive Capacity ' },
        { name: '7.5W', text: 'Wireless Charging Output' },
    ],
    '15361644593225': [
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '7.5W', text: 'Wireless Charging Output' },
    ],
    '7302855557193': [
        { name: '5,000mAh', text: 'Massive Capacity' },
        { name: '15W', text: 'Wireless Charging Output' },
    ],
    '7395983294537': [
        { name: '5,000mAh', text: 'Massive Capacity' },
        { name: '15W', text: 'Wireless Charging Output' },
    ],
    '15416976769097': [
        { name: '25W Wireless Output', text: 'Qi2.2 Certified' },
        { name: 'Foldable', text: '3-in-1 Design' },
        { name: 'For iPhone', text: 'Apple Watch, AirPods, and More' },
    ],

    // ca
    '15219601539443': [
        { name: '25W Wireless Output', text: 'Qi2.2 Certified' },
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '36W', text: 'Built-in USB-C Cable' },
    ],
    '15219601015155': [
        { name: '15W Wireless Output', text: 'Qi2 Certified' },
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: 'Multi angled', text: 'Foldable Kickstand' },
    ],
    '15126377234803': [
        { name: '5,000mAh', text: 'Massive Capacity ' },
        { name: '7.5W', text: 'Wireless Charging Output' },
    ],
    '15126380118387': [
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '7.5W', text: 'Wireless Charging Output' },
    ],
    '8339992051866': [
        { name: '5,000mAh', text: 'Massive Capacity' },
        { name: '15W', text: 'Wireless Charging Output' },
    ],
    '15040389579123': [
        { name: '5,000mAh', text: 'Massive Capacity' },
        { name: '15W', text: 'Wireless Charging Output' },
    ],
    '15219601801587': [
        { name: '25W Wireless Output', text: 'Qi2.2 Certified' },
        { name: 'Foldable', text: '3-in-1 Design' },
        { name: 'For iPhone', text: 'Apple Watch, AirPods, and More' },
    ],
};

export const colorMapping: Record<string, string> = {
    white: '#ECECEC',
    black: '#3E3E3E',
    lightblue: '#c0defe',
};
